/**
 * Carte d'origine : inline le world.svg (Shopify Files) et colore
 * les pays d'origine (codes ISO dans data-countries) en couleur de gamme.
 * Multi-pays natif. Le SVG est mis en cache (un seul fetch par page).
 */
(function () {
  'use strict';
  var cache = {};

  // Dans world.svg, les pays MONO-tracé ont id="ISO" ; les pays MULTI-tracés
  // (îles / outre-mer) n'ont PAS d'id mais class="Nom anglais" répété sur chaque
  // tracé (France, Italie, USA, UK, Canada, Chine, Japon, Indonésie, Papouasie,
  // Grèce, Turquie…). On les cible donc par leur classe.
  var MULTI = {
    FR: 'France', IT: 'Italy', GB: 'United Kingdom', US: 'United States',
    CA: 'Canada', CN: 'China', JP: 'Japan', ID: 'Indonesia',
    PG: 'Papua New Guinea', GR: 'Greece', TR: 'Turkey'
  };

  var ACTIVE = 'origin-country--active';

  function highlight(el, svg) {
    var codes = (el.getAttribute('data-countries') || '')
      .split(',')
      .map(function (s) { return s.trim().toUpperCase(); })
      .filter(Boolean);
    // Index des tracés par classe de base (nom anglais), calculé une fois.
    // Robuste : compare le nom de base (classe débarrassée de la classe active),
    // donc tolérant aux multi-tracés (îles/outre-mer), aux noms à espaces
    // (« United States », « Papua New Guinea ») et aux ré-exécutions.
    var byName = {};
    var withClass = svg.querySelectorAll('[class]');
    for (var j = 0; j < withClass.length; j++) {
      var base = (withClass[j].getAttribute('class') || '').replace(ACTIVE, '').trim();
      if (!base) continue;
      (byName[base] = byName[base] || []).push(withClass[j]);
    }
    codes.forEach(function (c) {
      var byId = svg.querySelector('[id="' + c + '"]');
      if (byId) byId.classList.add(ACTIVE);
      var name = MULTI[c];
      var list = name && byName[name];
      if (list) {
        for (var i = 0; i < list.length; i++) list[i].classList.add(ACTIVE);
      }
    });
  }

  function load(el) {
    if (el.getAttribute('data-loaded') === '1') return;
    var src = el.getAttribute('data-src');
    if (!src) return;
    el.setAttribute('data-loaded', '1');

    var inject = function (txt) {
      el.innerHTML = txt;
      var svg = el.querySelector('svg');
      if (!svg) return;
      svg.removeAttribute('width');
      svg.removeAttribute('height');
      highlight(el, svg);
    };

    if (cache[src]) { inject(cache[src]); return; }

    fetch(src)
      .then(function (r) { return r.text(); })
      .then(function (t) { cache[src] = t; inject(t); })
      .catch(function () { el.setAttribute('data-loaded', ''); });
  }

  function run() {
    var els = document.querySelectorAll('.origin-world');
    for (var i = 0; i < els.length; i++) load(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('pageshow', run);
  document.addEventListener('shopify:section:load', run);
})();
